import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import React from 'react';
import { Control, useController } from 'react-hook-form';
import { StudentEnvironment } from '../../types';

export interface ExerciseFieldProps {
  control: Control<any>;
  studentEnvironment?: StudentEnvironment[];
  loading?: boolean;
  name: string;
}

const VesselField = ({ control, studentEnvironment, loading, name }: ExerciseFieldProps) => {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name, rules: { required: 'Please select a vessel' } });

  const getOptionLabel = option => {
    return studentEnvironment?.find(e => e.vesselName === option.vesselName)?.vesselName ?? '';
  };

  return (
    <Autocomplete
      data-cy="select-vessel"
      clearOnBlur
      disableClearable
      disabled={!studentEnvironment || studentEnvironment.length === 1}
      getOptionLabel={getOptionLabel}
      handleHomeEndKeys
      renderOption={(props, option) => (
        <li {...props} key={option.vesselName} data-cy={`select-option-${getOptionLabel(option)}`}>
          {getOptionLabel(option)}
        </li>
      )}
      isOptionEqualToValue={(option, value) => option.vesselName === value.vesselName}
      options={studentEnvironment?.map(item => ({ vesselName: item.vesselName, vesselCode: item.vesselCode })) ?? []}
      renderInput={params => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          error={!!error}
          helperText={error?.message}
          label="Vessel"
          required
        />
      )}
      {...field}
      onChange={(event, option) => {
        field.onChange(option);
      }}
    />
  );
};

export default VesselField;
